import React from 'react';
import { Box, Typography } from '@mui/material';
import { SectionFieldProps } from './types';

const SectionField: React.FC<SectionFieldProps> = ({ label, children }) => (
  <Box>
    <Box display="flex" alignItems="center" gap={1} mb={1}>
      <Typography variant="body1" color="primary">
        {label}
      </Typography>
    </Box>
    <Typography variant="body1">{children}</Typography>
  </Box>
);

export default SectionField;
